module.exports = {
  Amberlink: {
    layPercentageAtWeek: {
      18: 2.0,
      19: 24.0,
      20: 63.0,
      21: 80.0,
      22: 90.0,
      23: 93.4,
      24: 95.0,
      25: 95.3,
      26: 95.5,
      27: 95.5,
      28: 95.4,
      29: 95.2,
      30: 95.1,
      31: 94.9,
      32: 94.8,
      33: 94.6,
      34: 94.5,
      35: 94.3,
      36: 94.1,
      37: 93.9,
      38: 93.7,
      39: 93.5,
      40: 93.3,
      41: 93.1,
      42: 92.9,
      43: 92.7,
      44: 92.5,
      45: 92.3,
      46: 92.0,
      47: 91.8,
      48: 91.5,
      49: 91.3,
      50: 91.0,
      51: 90.8,
      52: 90.5,
      53: 90.2,
      54: 89.9,
      55: 89.6,
      56: 89.3,
      57: 89,
      58: 88.7,
      59: 88.4,
      60: 88.1,
      61: 87.8,
      62: 87.4,
      63: 87.1,
      64: 86.7,
      65: 86.4,
      66: 86,
      67: 85.7,
      68: 85.3,
      69: 85,
      70: 84.6,
      71: 84.2,
      72: 83.8,
      73: 83.4,
      74: 83,
      75: 82.6,
      76: 82.1,
      77: 81.6,
      78: 81.1,
      79: 80.6,
      80: 80.1,
      81: 79.5,
      82: 78.9,
      83: 78.3,
      84: 77.6,
      85: 76.9,
      86: 76.1,
      87: 75.3,
      88: 74.4,
      89: 73.5,
      90: 72.6,
    },
  },
  Leghorn: {
    layPercentageAtWeek: {
      19: 5.9,
      20: 43.6,
      21: 70.0,
      22: 85.8,
      23: 92.9,
      24: 94.4,
      25: 94.8,
      26: 95.0,
      27: 95.2,
      28: 95.3,
      29: 95.4,
      30: 95.5,
      31: 95.5,
      32: 95.5,
      33: 95.5,
      34: 95.5,
      35: 95.4,
      36: 95.3,
      37: 95.2,
      38: 95.0,
      39: 94.9,
      40: 94.7,
      41: 94.5,
      42: 94.3,
      43: 94.0,
      44: 93.8,
      45: 93.6,
      46: 93.3,
      47: 93.0,
      48: 92.8,
      49: 92.5,
      50: 92.2,
      51: 91.9,
      52: 91.6,
      53: 91.3,
      54: 91.0,
      55: 90.7,
      56: 90.4,
      57: 90.1,
      58: 89.8,
      59: 89.5,
      60: 89.2,
      61: 88.9,
      62: 88.6,
      63: 88.2,
      64: 87.8,
      65: 87.4,
      66: 87.0,
      67: 86.7,
      68: 86.3,
      69: 85.9,
      70: 85.5,
      71: 85.2,
      72: 84.8,
      73: 84.4,
      74: 84.0,
      75: 83.7,
      76: 83.3,
      77: 82.9,
      78: 82.5,
      79: 82.1,
      80: 81.8,
      81: 81.4,
      82: 81.0,
      83: 80.6,
      84: 80.3,
      85: 79.9,
      86: 79.5,
      87: 79.1,
      88: 78.8,
      89: 78.4,
      90: 78.0,
      91: 77.6,
      92: 77.2,
      93: 76.9,
      94: 76.5,
      95: 76.1,
      96: 75.7,
      97: 75.4,
      98: 75.0,
      99: 74.6,
      100: 74.2,
    }
  },
}



// WEBPACK FOOTER //
// ./src/layerAdmin/data/idealData.js